<template>

    <section v-if="!values.payByCompany" class="member-signup custom-margin">

        <div class="row">
            <div class="col-xs-12">
                <h2 class="headline-lg medium" v-if="(product.paymentHeader)">{{ product.paymentHeader }}</h2>
                <div class="disclaimer" v-if="(product.paymentDescription)">{{ product.paymentDescription }}</div>
            </div>
        </div>

        <div class="row">
            <!-- DISABLED FOR NOW - STO / 2024-03-12 -->
            <!-- <div class="col-md-6 col-xs-12"> -->
            <div class="col-xs-12">

                <div class="grid-wrapper">
                    <div>
                        <div>{{ d.union }}</div>
                        <div v-if="product.subscriptiontype === 'student'" class="promotion-detail">
                              {{ d.studentpricepromotionaldetail }}
                        </div>
                    </div>
                    <div class="box box-right"><span class="pricetag darkblue">{{ product.priceunion == 0.0 ? d.free : product.priceunion  }}</span> <span class="suffix" v-bind:class="{ 'hidden': product.priceunion == 0.0}">{{d.productpricesuffix}}</span></div>

                    <div class="box">{{ d.unemploymentinsurance }}</div>
                    <div class="box box-right"><span v-bind:class="{ 'inactive' : !product.unemploymentinsuranceselected}" class="pricetag darkblue">{{ product.priceunemployment == 0.0 ? d.free : product.priceunemployment }}</span> <span class="suffix" v-bind:class="{ 'hidden': product.priceunemployment == 0.0 }">{{d.productpricesuffix}}</span></div>
                </div>
                <div class="grid-wrapper">
                    <div class="box blue"><strong>{{d.paymentdetailsforpaymentnow}}</strong></div>
                    <div class="box box-right"><span class="pricetag" >{{ calculateTotalPrice }}</span> <span class="suffix" v-bind:class="{ 'hidden': calculateTotalPrice == d.free}">{{d.productpricesuffix}}</span></div>
                </div>

                <div class="terms" v-if="product.unemploymentinsuranceselected">
                    {{ d.paymentdetailsterms }}
                </div>


            </div>

            <!-- DISABLED FOR NOW - STO / 2024-03-12 -->
            <!--
            <div class="col-md-6 col-xs-12 relative">
                <div class="campaign-container" v-if="!product.promocodeused">
                    <CampaignInput></CampaignInput>
                </div>

                <div v-show="product.promocodeused">
                    <p class="promo-code-used-title">{{ d.promocodeusedtitle }}</p>
                    <p>{{ product.campaignText }}</p>
                </div>

                <div v-if="product.promocodeused" class="promo-used-wrapper">
                    <p>
                        <strong>{{d.promocodeusedtitle}}</strong><br />
                        <span class="richtext">{{ product.campaignText }}</span>
                    </p>
                </div>
            </div>
            -->

        </div>

    </section>

</template>

<script>
    // import axios from 'axios'
    import useVuelidate from '@vuelidate/core'
    // DISABLED FOR NOW - STO / 2024-03-12
    // import CampaignInput from '../FormComponents/CampaignInput.vue'

  export default {
    components: {
        // DISABLED FOR NOW - STO / 2024-03-12
        // CampaignInput
    },
    setup () {
      // we use vuelidate for validation 
      // https://vuelidate-next.netlify.app/
      return { v$: useVuelidate({$lazy:true}) }
    },
    data: (instance) => {
      return {
        subscriptionType: instance.store.subscriptiontype,
        values: instance.store[instance.store.currentCulture].values.personalDetails,
        product: instance.store[instance.store.currentCulture].values.productDetails,
        d: instance.store[instance.store.currentCulture].dictionary,
        culture: instance.store.currentCulture,
      }
    },
    computed: {
        calculateTotalPrice: function() {
        let total = this.product.priceunion;
        if (this.product.unemploymentinsuranceselected) {
          total += this.product.priceunemployment;
        }
        return total === 0.0 ? this.d.free : total;
      }
    },
    watch: {

    },
    methods: {

    },
    mounted() {
        this.emitter.on('culture-change', () => {
            this.values = this.store[this.store.currentCulture].values.personalDetails;
            this.d = this.store[this.store.currentCulture].dictionary;
            this.v$.$reset()
        });
    },
  }
</script>

<style lang="postcss" scoped >

.grid-wrapper{
    display: grid;
    grid-template-columns: 50% calc(50% - 10px);

    align-content: stretch; 
    align-items: stretch;

    &:first-of-type {
        border-bottom: 1px solid rgba(0, 25, 101, .3);
        padding-bottom: 8px;
        margin-bottom: 8px;
    }

    .darkblue {
    color: var(--color-darkblue);
    }
    .blue {
        color: var(--color-blue);
    }
}

.promotion-detail {
    font-family: var(--font-it-md);
    font-size: var(--font-size-xxs);
    margin-bottom: 4px;
    font-weight: 400;

    @media screen and (min-width: 1024px) {
    font-size: var(--font-size-xs);
    }
}

.box, .box-right {
    display: flex;
    align-items: center;
    justify-content: flex-start;

    &:not(.box-right) {
        font-family: var(--font-it-ex);
        letter-spacing: var(--letter-spacing);
    }
}

.box-right {
    justify-content: flex-end;
    text-align: right;
}

.button-wrapper{
    display: grid;
    grid-template-columns: 100%;

    align-content: stretch; 
    align-items: stretch;

    padding: 50px 0;
}

.button-container-item{
    display: flex;
    align-items: center;
    justify-self: center;
}
div.disclaimer {
    margin-bottom: 20px;
} 
.hidden {
    display: none;
}
.relative {
    position: relative;
}

.terms {
    font-size: 12px;
    font-family: var(--font-it-ex);
    letter-spacing: var(--letter-spacing);
    margin-top: 10px;
}

.pricetag {
    font-family: var(--font-it-md);
    font-weight: var(--font-weight-regular);
    font-size: 28px;

    margin-bottom: 0;

    color: var(--color-blue);
}

.suffix {
    font-family: var(--font-it-ex);
    font-weight: var(--font-weight-regular);
    letter-spacing: var(--letter-spacing);
    margin-left: 8px;
    padding-top: 8px;
}

.promo-used-wrapper {
    background: var(--color-grey-5);
    padding: 20px 33px 42px 33px;
    margin-top: 10px;

    p {
        margin: 0;
    }
}

.campaign-container {
    display: flex;
    margin-top: var(--grid-gutter);
    @media screen and (min-width: 1024px) {
    margin-top: 0;
    height: 65%;
    }
}

.custom-margin{
  padding-top: 50px;
}

.inactive, button:disabled  {
    opacity: 0.3;
}
</style>